"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformSdkApi = void 0;
const SdPlatformSdkErrorMapping_1 = require("./SdPlatformSdkErrorMapping");
const axios_1 = __importDefault(require("axios"));
var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["POST"] = "POST";
    Method["PATCH"] = "PATCH";
    Method["DELETE"] = "DELETE";
})(Method || (Method = {}));
/**
 * Base API used by the authentication API and the ShapeDiver Platform resource APIs.
 */
class SdPlatformSdkApi {
    constructor(__config) {
        this.__config = __config;
        this.__onRequestStart = [];
        this.__onRequestFinished = [];
    }
    __toQueryString(data) {
        const keys = Object.keys(data);
        const mapFn = (key) => data[key] ? `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}` : '';
        return `?${keys.map(mapFn).join('&')}`;
    }
    __resolveRequest(url, method, config, data, headers) {
        const request = {
            url,
            method,
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "",
            },
        };
        if (config.access_token) {
            request.headers["Authorization"] = `Bearer ${config.access_token}`;
        }
        else if (config.basic_access_token) {
            request.headers["Authorization"] = `Basic ${config.basic_access_token}`;
        }
        if (config.client_id) {
            request.headers["X-ShapeDiver-Client"] = config.client_id;
        }
        if (headers && Object.keys(headers).length > 0) {
            for (const key in headers) {
                request.headers[key] = headers[key];
            }
        }
        if (config.username) {
            request.auth = {
                username: config.username,
                password: config.password
            };
        }
        if (data) {
            request.data = data;
        }
        return request;
    }
    __afterRequest(id, requestConfig, response) {
        if (this.__onRequestFinished.length > 0) {
            // NOTE shallow copy for now
            // TODO use library for deep cloning!
            const requestConfigCopy = Object.assign({}, requestConfig);
            const responseCopy = Object.assign({}, response);
            const requestFinishedEvent = {
                id,
                requestParams: {
                    method: requestConfigCopy.method,
                    url: requestConfigCopy.url,
                    data: undefined,
                },
                response: {
                    status: responseCopy.status,
                    data: responseCopy.data
                },
            };
            this.__onRequestFinished.forEach(x => x(requestFinishedEvent));
        }
    }
    __fetch(id, requestInit) {
        return __awaiter(this, void 0, void 0, function* () {
            // fire event indicating that request is starting
            if (this.__onRequestStart.length > 0) {
                // NOTE shallow copy for now
                // TODO use library for deep cloning!
                const requestInitCopy = Object.assign({}, requestInit);
                const requestStartEvent = {
                    id,
                    requestParams: {
                        method: requestInitCopy.method,
                        url: requestInitCopy.url,
                        data: requestInitCopy.data,
                    }
                };
                this.__onRequestStart.forEach(x => x(requestStartEvent));
            }
            // request
            try {
                const response = yield (0, axios_1.default)(Object.assign({}, requestInit));
                this.__afterRequest(id, requestInit, response);
                return response;
            }
            catch (e) {
                const error = (0, SdPlatformSdkErrorMapping_1.mapToApiError)(e);
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (e.response)
                    this.__afterRequest(id, requestInit, e.response);
                throw error;
            }
        });
    }
    /**
     * Register callbacks for request start events.
     * @param cb
     */
    onRequestStart(cb) {
        this.__onRequestStart.push(cb);
    }
    /**
     * Register callbacks for request finished events.
     * @param cb
     */
    onRequestFinished(cb) {
        this.__onRequestFinished.push(cb);
    }
    get(id, url, config, queryParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const qp = queryParams ? this.__toQueryString(queryParams) : "";
            const request = this.__resolveRequest(`${this.__config.baseUrl}/${url}${qp}`, Method.GET, config);
            const response = yield this.__fetch(id, request);
            return Promise.resolve(response.data);
        });
    }
    post(id, url, data, config, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.__resolveRequest(`${this.__config.baseUrl}/${url}`, Method.POST, config, data, headers);
            const response = yield this.__fetch(id, request);
            return Promise.resolve(response.data);
        });
    }
    patch(id, url, data, config, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.__resolveRequest(`${this.__config.baseUrl}/${url}`, Method.PATCH, config, data);
            const response = yield this.__fetch(id, request);
            return Promise.resolve(response.data);
        });
    }
    delete(id, url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.__resolveRequest(`${this.__config.baseUrl}/${url}`, Method.DELETE, config);
            const response = yield this.__fetch(id, request);
            return Promise.resolve(response.data);
        });
    }
}
exports.SdPlatformSdkApi = SdPlatformSdkApi;
//# sourceMappingURL=SdPlatformSdkApi.js.map